export const API_URL = "https://server.datasenseai.com"; 
// export const API_URL = "http://localhost:4000"; 

export const api = {
    async fetchSlotProgress(clerkId) {
        try {
            const res = await fetch(`${API_URL}/slot/progress/${clerkId}`);
            if (!res.ok) throw new Error("Failed to fetch slot progress");
            return await res.json();
        } catch (error) {
            console.error("Fetch Slot Error:", error);
            return null;
        }

    },

    async syncSlotProgress(clerkId, progress) {
        try {
            await fetch(`${API_URL}/slot/progress/sync`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ clerkId, progress })
            });
        } catch (error) {
            console.error("Sync Slot Error:", error);
        }
    }
};
